export const colors = {
  text: {
    1: '#fff',
    2: '#D7E9FF',
    3: '#5f7a99',
    4: '#535966',
    highlight: '#419ceb',
  },

  outline: '#708aa7',

  grey: {
    500: '#5F7A99',
    700: '#708aa7',
    800: '#364C67',
  },
  blue: {
    500: '#419ceb',
  },
  green: {
    500: '#1B3442',
  },

  strokeReflection:
    'linear-gradient(41.89deg, #53399B 0.69%, #7DE0FF 38.19%, #504179 72.85%, #84E2FF 100%)',
  radialGradient:
    'radial-gradient(97.48% 82.4% at 49.69% 76.45%, #3082E1 0%, #3D3786 31.18%, transparent 100%)',

  gradients: {
    primary: 'linear(to-l, #8671C0 0%, #4DBEE1 100%)',
    green: 'linear(239.18deg, #1B3442 27.18%, #0A161F 96.11%)',
  },
}

export default colors
